import { useState, useEffect, useRef } from 'react'
import './index.css'

function ScannedSite({ domain, handleClick, status, dateAddedByUser }) {
    const [confirming, setConfirming] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        return () => clearTimeout(timeoutRef.current);
    }, []);

    const onDeleteClick = () => {
        if (confirming) {
            clearTimeout(timeoutRef.current);
            handleClick(domain);
        } else {
            setConfirming(true);
            timeoutRef.current = setTimeout(() => setConfirming(false), 3000);
        }
    };

    let statusClass;

    const now = new Date();
    const addedDate = new Date(dateAddedByUser);
    const diffMs = now - addedDate;
    const diffMinutes = diffMs / (1000 * 60);

    if (status) {
        statusClass = "positive-status";
    } else if (diffMinutes < 5) {
        statusClass = "pending-status";
    } else {
        statusClass = "negative-status";
    }

    return (
        <div className='feed-item-border scanned-site'>
            <div className='feed-item site-scan-holder'>
                <div className='domain-name small-text'>{domain}</div>
                <div className={'status-globule ' + statusClass}>
                    {status ? "Success" : diffMinutes < 5 ? "Pending" : "Failed"}
                </div>
                {confirming ? (
                    <div className='delete-confirm-btn' onClick={onDeleteClick}>Sure?</div>
                ) : (
                    <button
                        className="delete-button close-btn"
                        onClick={onDeleteClick}
                        aria-label="Delete"
                    >
                        <svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>
                    </button>
                )}
            </div>
        </div>
    );
}

export default ScannedSite;